import { Box, Typography } from "@mui/material";
import borders from "assets/theme/base/borders";
import SectionDivider from "pages/Presentation/sections/SectionDivider";
import { getPrizeBreakdown } from "utils/solana/prices";

function PrizesBreakdown({ id, rewardPool }) {
  const breakdown = getPrizeBreakdown(rewardPool);
  return (
    <Box
      id={id}
      py={10}
      sx={{
        mt: 6,
        px: 2,
      }}
    >
      <SectionDivider title="🎯 Reward Distribution" />

      <Box
        id="prize-breakdown"
        sx={{
          backgroundColor: "#fffde7",
          border: "4px solid #FFD700",
          borderRadius: borders.borderRadius.xl,
          p: 4,
          // maxWidth: 700,
          mx: "auto",
          boxShadow: "6px 6px 0 rgba(0,0,0,0.2)",
          textAlign: "center",
        }}
      >
        <>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h3" sx={{ textShadow: "1px 1px white", mb: 2 }}>
              💰 <strong>Total Collected:</strong> {breakdown.totalCollected.toFixed(2)} FLART
            </Typography>
            <Typography variant="body1" sx={{ textShadow: "1px 1px white", mb: 1 }}>
              🧾 Fees & Deductions
            </Typography>
            <Typography sx={{ textShadow: "1px 1px white" }}>
              • Platform Commission: <strong>{breakdown.commission.toFixed(2)} FLART</strong>
            </Typography>
            <Typography sx={{ textShadow: "1px 1px white" }}>
              • Burned: <strong>{breakdown.burn.toFixed(2)} FLART</strong>
            </Typography>
            <Typography sx={{ textShadow: "1px 1px white" }}>
              • Future Rewards: <strong>{breakdown.future.toFixed(2)} FLART</strong>
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" sx={{ textShadow: "1px 1px white", mb: 1 }}>
              🏆 Top 3 Prize Breakdown
            </Typography>

            {/* First Place */}
            <Box sx={{ mb: 1, pl: 2 }}>
              <Typography sx={{ fontWeight: "bold", color: "#facc15" }}>🥇 First Place</Typography>
              <Typography sx={{ textShadow: "1px 1px white" }}>
                • Creator: <strong>{breakdown.first.creator.toFixed(2)} FLART</strong>
              </Typography>
              <Typography sx={{ textShadow: "1px 1px white" }}>
                • Total Voters: <strong>{breakdown.first.voters.toFixed(2)} FLART</strong>
              </Typography>
            </Box>

            {/* Second Place */}
            <Box sx={{ mb: 1, pl: 2 }}>
              <Typography sx={{ fontWeight: "bold", color: "#c0c0c0" }}>🥈 Second Place</Typography>
              <Typography sx={{ textShadow: "1px 1px white" }}>
                • Creator: <strong>{breakdown.second.creator.toFixed(2)} FLART</strong>
              </Typography>
              <Typography sx={{ textShadow: "1px 1px white" }}>
                • Total Voters: <strong>{breakdown.second.voters.toFixed(2)} FLART</strong>
              </Typography>
            </Box>

            {/* Third Place */}
            <Box sx={{ pl: 2 }}>
              <Typography sx={{ fontWeight: "bold", color: "#cd7f32" }}>🥉 Third Place</Typography>
              <Typography sx={{ textShadow: "1px 1px white" }}>
                • Creator: <strong>{breakdown.third.creator.toFixed(2)} FLART</strong>
              </Typography>
              <Typography sx={{ textShadow: "1px 1px white" }}>
                • Total Voters: <strong>{breakdown.third.voters.toFixed(2)} FLART</strong>
              </Typography>
            </Box>
          </Box>
        </>
      </Box>
    </Box>
  );
}

export default PrizesBreakdown;
